import { useTranslation } from 'react-i18next';
import { Pill } from '@components/ui/Pill/Pill';
import { useLang } from '@hooks/useLang';
import type { HelpLanguage } from '@apis/help';
import { useHelpGuides } from './useHelp';
import styles from './HelpCenterPage.module.css';

interface IEnglishOnlyPillProps {
  /** The language the guide is actually served in. */
  language: HelpLanguage;
}

/** Marks a guide served in English to a user reading the app in another language. */
export function EnglishOnlyPill({ language }: IEnglishOnlyPillProps) {
  const { t } = useTranslation();
  const uiLanguage = useLang();
  const { isPlaceholderData } = useHelpGuides();
  // Until the new language's list arrives, the labels on screen are the old language's, so no "English" claim yet.
  if (language === uiLanguage || isPlaceholderData) return null;
  return <Pill className={styles.englishOnly}>{t('help.englishOnly')}</Pill>;
}
